import React, { useContext, useEffect, useState } from "react";
import { MainStore } from "core/store";
import { Button, Divider, Empty, Image, Input, Modal } from "antd";
import { DeleteOutlined, PlusCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import LuckyDrawTicket from "./ticket";
import Announce from "assets/images/png/announce-icon.png";
import "dayjs/locale/th";
import "./lucky-draw-style.css";
import api from "api";
import Loading from "components/loading";

const { OTP } = Input;

export default function LuckyDraw() {
  const { userData, setReloadData } = useContext(MainStore);
  const [isLoading, setIsLoading] = useState(false);
  const [currentLuckyDraw, setCurrentLuckyDraw] = useState({});
  const [selectLuckyDraw, setSelectLuckyDraw] = useState(null);
  const [tokenLuckyDrawByUser, setTokenLuckyDrawByUser] = useState(0);
  const [isClosed, setIsClosed] = useState(null);
  const [confirmAddNumber, setConfirmAddNumber] = useState(false);

  const [myNumbers, setMyNumbers] = useState([]);
  const [isMyNumbersLoading, setIsMyNumbersLoading] = useState(false);
  const [numberList, setNumberList] = useState([]);

  function onAddNumber() {
    let my_number = [...numberList];
    my_number.push(null);
    setNumberList(my_number);
    setTokenLuckyDrawByUser((prev) => ({
      ...prev,
      totalToken: prev.totalToken - 1,
    }));
  }

  function onChangeOTP(e, index) {
    let my_number = [...numberList];
    my_number[index] = e;
    setNumberList(my_number);
  }

  function onRemoveOTP(index) {
    let my_number = [...numberList];
    my_number.splice(index, 1);
    setNumberList(my_number);
    setTokenLuckyDrawByUser((prev) => ({
      ...prev,
      totalToken: prev.totalToken + 1,
    }));
  }

  async function handleSubmit() {
    setIsLoading(true);

    setConfirmAddNumber(false);

    const params = {
      numbers: numberList,
      owner_id: userData.id,
      caddy_first_name: userData.first_name,
      caddy_last_name: userData.last_name,
      caddy_display_name: userData.display_name,
      lucky_draw_start_date: currentLuckyDraw.start_date,
      lucky_draw_end_date: currentLuckyDraw.end_date,
      lucky_draw_name: currentLuckyDraw.name,
      form_lucky_draw_id: currentLuckyDraw.id,
      is_win: false,
    };

    const formData = new FormData();

    Object.keys(params).map((key) => {
      return formData.append(key, params[key]);
    });

    try {
      const { data } = await api.luckyDrawApi.createLuckyDraw(params, false);
      if (data) {
        getLuckyDrawNumbers(currentLuckyDraw.id, true);
        setReloadData(true);
      }
    } catch (error) {
      console.log("err", error);
    } finally {
      setIsLoading(false);
      await getLuckyDrawMasterData();
    }

    setNumberList([]);
  }

  useEffect(() => {
    getLuckyDrawMasterData();
  }, []);

  async function getLuckyDrawMasterData() {
    setIsLoading(true);
    try {
      const { data } = await api.masterDataApi.getListLuckydraw();
      const info = data.data;
      if (info) {
        setCurrentLuckyDraw(info.current);
        setSelectLuckyDraw(info.current.id);
        getLuckyDrawNumbers(info.current.id);
      } else {
        setCurrentLuckyDraw(null);
        setSelectLuckyDraw(null);
        getLuckyDrawNumbers(null);
      }
      setTokenLuckyDrawByUser(info.userToken);
    } catch (error) {
      setCurrentLuckyDraw(null);
      setSelectLuckyDraw(null);
      getLuckyDrawNumbers(null);
      console.log("err", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function getLuckyDrawNumbers(lucky_draw_id) {
    const caddyId = userData?.id;
    if (lucky_draw_id) {
      setIsMyNumbersLoading(true);
      try {
        const { data } = await api.luckyDrawApi.getLuckyDrawById(
          caddyId,
          lucky_draw_id
        );
        setMyNumbers(data.data);
      } catch (error) {
        setMyNumbers([]);
        console.log("err", error);
      } finally {
        setIsMyNumbersLoading(false);
      }
    }
  }

  function checkIsNotDuplicate(number, index) {
    let isDuplicate = true;

    const find_number_list = numberList.find((num) => num === number);
    const find_number_list_index = numberList.findIndex(
      (num) => num === number
    );
    const find_my_number_list = myNumbers.find(
      (value) => value.number === number
    );

    if (
      (find_number_list && find_number_list_index !== index) ||
      find_my_number_list
    )
      isDuplicate = false;

    return isDuplicate;
  }

  return (
    <div className="lucky-draw-container">
      <Loading visible={isLoading} />
      <Modal
        open={confirmAddNumber}
        centered
        footer={false}
        closable={false}
        onClose={() => setConfirmAddNumber(false)}
      >
        <center>
          <h2>ยืนยันหมายเลข</h2>
        </center>
        <Divider style={{ margin: "5px 0px 10px 0px" }} />
        <div style={{ fontSize: 16 }}>
          <center style={{ fontSize: 24 }}>
            <b>{numberList.join(", ")}</b>
          </center>
          <center style={{ color: "red" }}>
            หากยืนยันแล้วจะไม่สามารถแก้ไขได้.
          </center>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            marginTop: 10,
          }}
        >
          <Button
            style={{ width: "100%" }}
            type="primary"
            onClick={() => handleSubmit()}
          >
            ใช่, ยืนยัน
          </Button>
          <Button
            style={{ width: "100%" }}
            danger
            onClick={() => setConfirmAddNumber(false)}
          >
            ไม่ใช่
          </Button>
        </div>
      </Modal>
      <div className="lucky-draw-header">
        <center>ทายเลขชิงรางวัล</center>
        <center
          style={{
            fontSize: 14,
            fontWeight: "bold",
            marginTop: 5,
            color: "#777777",
          }}
        >
          {userData?.display_name} ({userData?.code})
        </center>
      </div>

      <div
        style={{
          padding: "10px 20px 20px 20px",
          position: "sticky",
          left: 0,
          zIndex: 8,
          display: "flex",
          flexDirection: "column",
          gap: 15,
          overflow: "hidden",
        }}
      >
        {/* {(userData.register_state === 3) | (userData.register_state === 1) ? <AlertError isClosed={isClosed} setIsClosed={setIsClosed} reject_reason={userData.reject_reason} register_state={userData.register_state} /> : null} */}

        <div
          style={{
            padding: 20,
            borderRadius: 15,
            background: "white",
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          }}
        >
          <center>
            <h2 style={{ fontWeight: "bold", marginBottom: 10 }}>
              เหรียญลุ้นรางวัลของคุณ
            </h2>
          </center>
          <Divider style={{ margin: "15px 0px" }} />
          <div style={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
            <center
              style={{ display: "flex", flexDirection: "column", gap: 10 }}
            >
              <b>เหรียญลุ้นรางวัลฟรี</b>
              <div
                style={{ fontSize: 32, fontWeight: "bold", color: "#777777" }}
              >
                {tokenLuckyDrawByUser?.luckyDrawFreeToken ?? 0}
              </div>
              {tokenLuckyDrawByUser?.luckyDrawFreeToken !== 0 &&
                currentLuckyDraw && (
                  <div style={{ fontSize: 10 }}>
                    หมดอายุ :{" "}
                    {dayjs(currentLuckyDraw?.end_date).format("DD/MM/YYYY")}{" "}
                    12.00
                  </div>
                )}
            </center>
            <center
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                borderLeft: "1px solid rgba(5, 5, 5, 0.06)",
              }}
            >
              <b>เหรียญลุ้นรางวัล</b>
              <div
                style={{ fontSize: 32, fontWeight: "bold", color: "#777777" }}
              >
                {tokenLuckyDrawByUser?.luckyDrawToken ?? 0}
              </div>
            </center>
          </div>
        </div>

        <div
          style={{
            padding: 20,
            borderRadius: 15,
            background: "white",
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
            }}
          >
            <Image
              style={{ transform: "rotate(-30deg)" }}
              src={Announce}
              preview={false}
              width={200}
            />
            <div style={{ fontSize: 14 }}>
              <b style={{ color: "red" }}>ทายเลขชิงรางวัล เลขท้าย 3 ตัว</b>{" "}
              ของรางวัลที่ 1{" "}
              <b style={{ color: "red" }}>ลุ้นรับรางวัลมูลค่า 1,000 บาท</b>{" "}
              เราแจกทุกงวด ทายไม่ถูกแต่ใกล้เคียงเราก็แจก
              ดังนั้นอย่าลืมทายเลขกันเข้ามาลุ้นรับโชคกันทุกๆ งวดนะคะ
            </div>
          </div>
        </div>

        {currentLuckyDraw ? (
          <>
            <center>
              <div style={{ padding: "5px 20px" }}>
                {currentLuckyDraw?.id && (
                  <h2 style={{ fontWeight: "bold", margin: 0 }}>
                    งวดประจำวันที่{" "}
                    {dayjs(currentLuckyDraw?.end_date).format("DD MMMM YYYY")}
                  </h2>
                )}
              </div>
            </center>

            {parseInt(userData?.lucky_draw_free_token) !== 0 ||
            parseInt(userData?.lucky_draw_token) !== 0 ? (
              !currentLuckyDraw?.is_ended && (
                <div
                  style={{
                    padding: 20,
                    borderRadius: 15,
                    background: "white",
                    boxShadow:
                      "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  }}
                >
                  {numberList?.map((number, index) => {
                    return (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 10,
                            marginTop: 10,
                          }}
                        >
                          <h3 style={{ margin: 0 }}>ลำดับที่ {index + 1}</h3>
                          <DeleteOutlined
                            style={{
                              color: "red",
                              fontSize: 18,
                              cursor: "pointer",
                            }}
                            onClick={() => onRemoveOTP(index)}
                          />
                        </div>
                        <OTP
                          type="number"
                          status={
                            !/^\d{0,3}$/.test(number) ||
                            !checkIsNotDuplicate(number, index)
                              ? "error"
                              : ""
                          }
                          id={index}
                          value={number}
                          length={3}
                          style={{ width: "100%" }}
                          onChange={(e) => onChangeOTP(e, index)}
                        />
                        {!/^\d{0,3}$/.test(number) && (
                          <div
                            style={{
                              color: "red",
                              fontSize: 12,
                              marginTop: 10,
                            }}
                          >
                            กรุณากรอกตัวเลขเท่านั้น
                          </div>
                        )}
                        {!checkIsNotDuplicate(number, index) && (
                          <div
                            style={{
                              color: "red",
                              fontSize: 12,
                              marginTop: 10,
                            }}
                          >
                            คุณเลือกหมายเลขนี้ไปแล้ว.
                          </div>
                        )}
                        <Divider style={{ margin: "10px 0px 10px 0px" }} />
                      </div>
                    );
                  })}
                  {tokenLuckyDrawByUser.totalToken > 0 && (
                    <center
                      style={{ cursor: "pointer" }}
                      onClick={() => onAddNumber()}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          border: "1px solid green",
                          borderRadius: 15,
                          padding: 10,
                        }}
                      >
                        <PlusCircleFilled
                          style={{ fontSize: 24, color: "green" }}
                        />
                        <b>เพิ่มหมายเลข</b>
                      </div>
                    </center>
                  )}
                  <Button
                    style={{ width: "100%", height: 40, marginTop: 15 }}
                    type="primary"
                    disabled={numberList.length === 0}
                    onClick={() => {
                      let passed = true;
                      numberList.map((number, index) => {
                        if (
                          !/^\d{0,3}$/.test(number) ||
                          !checkIsNotDuplicate(number, index)
                        )
                          passed = false;

                        return passed;
                      });

                      if (!passed) {
                        setConfirmAddNumber(false);
                      } else {
                        setConfirmAddNumber(true);
                      }
                    }}
                  >
                    ส่งหมายเลข
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}
          </>
        ) : (
          <center>
            <h2 style={{ margin: 0 }}>ยังไม่มีงวดรางวัล</h2>
          </center>
        )}

        <div
          style={{
            padding: 20,
            borderRadius: 15,
            background: "white",
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          }}
        >
          <center>
            <h2 style={{ fontWeight: "bold", marginBottom: 10 }}>
              หมายเลขทั้งหมด
            </h2>
          </center>
          <Divider style={{ margin: "15px 0px" }} />
          {isMyNumbersLoading ? (
            <Loading visible={true} />
          ) : myNumbers?.length > 0 ? (
            myNumbers?.map((value) => {
              return (
                <LuckyDrawTicket
                  number={value.number}
                  name={value.lucky_draw_name}
                />
              );
            })
          ) : (
            <Empty />
          )}
        </div>
      </div>
    </div>
  );
}
